import React from "react";
import Mermaid from "./Mermaid";

export default function MermaidContainer({ text, setError }) {
  return <Mermaid text={text} setError={setError} />;
}
